// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selected-wrapper[data-v-e3299836]{margin-bottom:20px}.selected-heading[data-v-e3299836]{font-weight:500;font-size:16px;line-height:140%;margin-bottom:10px}.selected-value[data-v-e3299836]{font-weight:400;font-size:14px;line-height:140%;margin-bottom:6px}@media screen and (min-width:1024px){.selected-heading[data-v-e3299836]{font-size:20px}.selected-value[data-v-e3299836]{font-size:18px}}", ""]);
// Exports
module.exports = exports;
